import { isEqual } from 'underscore';
import { createSelector } from 'reselect';
import getLang from 'I18n/utils/getLang';
import { getFormFieldLabel } from 'FormsUI/utils/FormFieldsUtils';
import { getLangToFormsLang } from 'FormsUI/utils/Lang';
// @ts-expect-error untyped dependency
import * as RequestState from 'FormsCommonComponents/lib/RequestState';
function getRoot(state) {
  return state.templates;
}
function getTemplates(state) {
  return getRoot(state).templates.filter((name, key) => !isEqual(key, 'sample'));
}
export const getTranslatedTemplates = createSelector(getTemplates, templates => {
  const lang = getLangToFormsLang(getLang());
  const translateField = field => {
    return Object.assign({}, field, {
      label: getFormFieldLabel(field.label, lang)
    });
  };
  return templates.map(definition => {
    return Object.assign({}, definition, {
      formFieldGroups: definition.formFieldGroups.map(group => {
        return Object.assign({}, group, {
          fields: group.fields.map(translateField)
        });
      })
    });
  });
});
export function getRequestState(state) {
  return getRoot(state) ? getRoot(state).requestState : RequestState.NOT_REQUESTED;
}